package one.healthium.settings.ui.components

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_3

@Composable
fun Section(label: String) {
    Text(
        modifier = Modifier
            .fillMaxWidth()
            .padding(12.dp)
            .padding(top = 12.dp),
        text = label,
        style = AppTheme.textStyles.sectionSmall,
        color = gray_3,
    )
}